import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import CustomDarkCheckbox from './CustomDarkCheckbox';
import { AGENCY_CATEGORIES } from "../constants/agencyCategories";
import { fetchProductsByCategory, deleteProduct } from "../services/productService";

import eye from '../assets/eye-svgrepo-com (2).svg';
import edit from '../assets/edit-3-svgrepo-com.svg';
import deletephoto from '../assets/delete-2-svgrepo-com.svg';
import leftarrow from '../assets/left-arrow-backup-2-svgrepo-com.svg';
import rightarrow from '../assets/right-arrow-backup-2-svgrepo-com.svg';
import arrowdown from '../assets/arrow-down-simple.png';

const Product2 = ({ category = AGENCY_CATEGORIES.CARS }) => {
  const navigate = useNavigate();

  // ✅ تحميل المنتجات من localStorage لو موجودة
  const [carProducts, setcarProducts] = useState(() => {
    const saved = localStorage.getItem("carProducts");
    return saved ? JSON.parse(saved) : [];
  });

  const [loading, setLoading] = useState(carProducts.length === 0);
  const [activeTab, setActiveTab] = useState(category || AGENCY_CATEGORIES.CARS);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [openItems, setOpenItems] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);

  const productsPerPage = 10;

  // ✅ دالة جلب المنتجات (مع تخزين في localStorage)
  const fetchProducts = async () => {
    try {
      const products = await fetchProductsByCategory(AGENCY_CATEGORIES.CARS);
      const productsWithId = (Array.isArray(products) ? products : []).map((p) => ({
        ...p,
        id: p._id || p.id,
      }));
      setcarProducts(productsWithId);
      localStorage.setItem("carProducts", JSON.stringify(productsWithId));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  // ✅ تحميل أول مرة أو تحديث كل 5 دقايق
    useEffect(() => {
      // لو مفيش بيانات في localStorage، هنجلب من الـ API
      if (carProducts.length === 0) fetchProducts();
  
      // تحديث البيانات كل 5 دقايق تلقائيًا
      const interval = setInterval(() => {
        console.log("⏰ Refreshing products data...");
        fetchProducts();
      }, 5 * 60 * 1000); // 5 دقائق
  
      return () => clearInterval(interval);
    }, [carProducts.length]);

  // ===== Filter by category =====
  const filteredProducts =
    activeTab === "All"
      ? carProducts
      : carProducts.filter((p) => p.Category === activeTab);

  const totalPages = Math.ceil(carProducts.length / productsPerPage);
  const indexOfLast = currentPage * productsPerPage;
  const indexOfFirst = indexOfLast - productsPerPage;
  const currentProducts = carProducts.slice(indexOfFirst, indexOfLast);

  // ===== Select =====
  const toggleSelectAll = () => {
    if (selectedProducts.length === currentProducts.length) {
      setSelectedProducts([]);
    } else {
      setSelectedProducts(currentProducts.map((p) => p.id));
    }
  };

  const toggleSelectProduct = (id) => {
    if (selectedProducts.includes(id)) {
      setSelectedProducts(selectedProducts.filter((pid) => pid !== id));
    } else {
      setSelectedProducts([...selectedProducts, id]);
    }
  };

  // ===== Toggle Mobile Card =====
  const toggleProduct = (id) => {
    setOpenItems((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  // ===== Delete =====
  const openDeleteModal = (product) => {
    setProductToDelete(product);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!productToDelete) return;

    try {
      await deleteProduct(AGENCY_CATEGORIES.CARS, productToDelete.id);

      const updatedProducts = carProducts.filter(
        (p) => p.id !== productToDelete.id
      );
      setcarProducts(updatedProducts);

      // ✅ نحدّث localStorage بعد الحذف
      localStorage.setItem("productsData", JSON.stringify(updatedProducts));

      setShowDeleteModal(false);
      setProductToDelete(null);
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  // ===== Pagination =====
  const handlePageSelect = (page) => {
    setCurrentPage(page);
    setIsOpen(false);
  };

  return (
    <div>
      {loading ? (
        <p className="text-center mt-10 dark:text-gray-300">Loading...</p>
      ) : (
        <>
          {/* Desktop Table */}
          <div className="overflow-hidden rounded-xl border border-gray-300 dark:border-[#3D3D3D] shadow-md">
            <table className="min-w-full border-collapse bg-white dark:bg-[#1A1A1B] hidden sm:table md:table">
              <thead className="bg-gray-100 border-b border-[#E7E7E7] dark:bg-black dark:border-[#3D3D3D] dark:text-gray-400">
                <tr>
                  <th className="flex w-[200px] justify-between text-left px-4 py-4 text-black text-sm font-medium select-none dark:text-gray-200">
                    <div className="flex gap-4 max-w-[200px]">
                      <CustomDarkCheckbox
                        checked={
                          selectedProducts.length === currentProducts.length &&
                          currentProducts.length > 0
                        }
                        onChange={toggleSelectAll}
                      />
                      Product
                    </div>
                  </th>
                  <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                    Rental Fee
                  </th>
                  <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                    Vendor
                  </th>
                  <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                    Location
                  </th>
                  <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                    Rating
                  </th>
                  <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                    Created At
                  </th>
                  <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                    Updated At
                  </th>
                  <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {carProducts.length === 0 ? (
                  <tr>
                    <td
                      colSpan={8}
                      className="px-4 py-4 text-center text-gray-500"
                    >
                      No products found.
                    </td>
                  </tr>
                ) : (
                  carProducts.map((p) => (
                    <tr
                      key={p.id}
                      className="border-b border-gray-200 hover:bg-gray-50 dark:hover:bg-[#2D2D2D] dark:border-[#3D3D3D]"
                    >
                      <td className="flex pl-4 items-center">
                        <CustomDarkCheckbox
                          checked={selectedProducts.includes(p.id)}
                          onChange={() => toggleSelectProduct(p.id)}
                        />
                        <div className="flex items-center gap-3 px-4 py-3 text-gray-800 text-sm">
                          <img
                            src={p.imageCover}
                            alt={p.name}
                            className="w-10 h-10 object-cover rounded-xl"
                          />
                          <div>
                            <p className="text-xs agarly-gradient-text">
                              ID {p.id}
                            </p>
                            <p className="dark:text-gray-300">{p.name} </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-gray-700 text-sm dark:text-gray-300">
                        ${Number(p.rentalFee).toFixed(2)}
                      </td>
                      <td className="px-4 py-3 text-gray-700 text-sm dark:text-gray-300">
                        {p.vendorName}
                      </td>
                      <td className="px-4 py-3 text-gray-700 text-sm dark:text-gray-300">
                        {p.location}
                      </td>
                      <td className="px-4 py-3 text-gray-700 text-sm dark:text-gray-300">
                        {p.rating || 0}
                      </td>
                      <td className="px-4 py-3 text-gray-700 text-sm dark:text-gray-300">
                        {new Date(p.createdAt).toLocaleDateString("en-GB")} <br />
                        {new Date(p.createdAt).toLocaleTimeString("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </td>
                      <td className="px-4 py-3 text-gray-700 text-sm dark:text-gray-300">
                        {new Date(p.updatedAt).toLocaleDateString("en-GB")} <br />
                        {new Date(p.updatedAt).toLocaleTimeString("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </td>
                      <td className="items-center text-gray-700 font-semibold text-sm flex gap-4">
                        <Link to={`/products/view-product/${p.id}`} state={{ product: p }}>
                          <img src={eye} alt="eye" className="w-5 h-5 inline" />
                        </Link>
                        <Link to={`/products/edit-product/${p.id}`} state={{ product: p, activeTab: AGENCY_CATEGORIES.CARS }}>
                          <img src={edit} alt="edit" className="w-5 h-5 cursor-pointer" />
                        </Link>
                        <img
                          src={deletephoto}
                          alt="delete"
                          className="w-5 h-5 cursor-pointer"
                          onClick={() => openDeleteModal(p)}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <div className="md:hidden flex flex-col border rounded-2xl mt-4">
            {carProducts.map(p => (
              <div key={p.id} className="rounded-2xl border-b p-4 bg-white dark:bg-[#1A1A1B]">
                <div className="flex justify-between items-center">
                  <div className="flex gap-2 items-center">
                    <img src={p.imageCover} alt={p.name} className="w-10 h-10 object-cover rounded-xl" />
                    <div>
                      <p className="text-xs agarly-gradient-text">ID {p.id}</p>
                      <p className="font-semibold dark:text-gray-300">{p.name} </p>
                    </div>
                  </div>
                  <button onClick={() => toggleProduct(p.id)}>
                    <img src={arrowdown} alt="" className={`w-5 h-5 transition-transform ${openItems[p.id] ? "rotate-180" : ""}`} />
                  </button>
                </div>
                {openItems[p.id] && (
                  <div className="mt-3 text-sm gap-2">
                    <p className="mb-1 dark:text-gray-300"><span className="text-gray-500 font-semibold">Rental Fee:</span> ${Number(p.rentalFee).toFixed(2)}</p>
                    <p className="mb-1 dark:text-gray-300"><span className="text-gray-500 font-semibold">Vendor name: </span>{p.vendorName}</p>
                    <p className="mb-1 dark:text-gray-300"><span className="text-gray-500 font-semibold">Location:</span> {p.location}</p>
                    <p className="mb-1 dark:text-gray-300"><span className="text-gray-500 font-semibold">Rating:</span> {p.rating || 0}</p>
                    <p className="mb-1 dark:text-gray-300"><span className="text-gray-500 font-semibold">Created At:</span> {new Date(p.createdAt).toLocaleString()}</p>
                    <p className="mb-1 dark:text-gray-300"><span className="text-gray-500 font-semibold">Updated At: </span> {new Date(p.updatedAt).toLocaleString()}</p>
                    <div className="flex gap-2 mt-1 items-center">
                      <span className="text-gray-500 font-semibold ">Actions: </span>
                      <Link to={`/products/view-product/${p.id}`} state={{ product: p }}>
                        <img src={eye} alt="eye" className="w-4 h-4 inline" />
                      </Link>
                      <Link to={`/products/edit-product/${p.id}`} state={{ product: p, activeTab: AGENCY_CATEGORIES.CARS }}>
                        <img src={edit} alt="edit" className="w-4 h-4 cursor-pointer" />
                      </Link>
                      <img src={deletephoto} alt="delete" className="w-4 h-4 cursor-pointer" onClick={() => openDeleteModal(p)} />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-between items-center mt-4">
            <p className="text-sm text-gray-700 dark:text-gray-400"><span className="text-gray-900 font-semibold dark:text-gray-200">{currentPage}</span> of {totalPages} Pages</p>
            <div className="flex gap-2 items-center">
              <button className="border-2 px-1 py-1 rounded-xl disabled:opacity-50" disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>
                <img src={leftarrow} alt="" className="w-5 h-5"/>
              </button>
              <div className="relative inline-block">
                <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-1 border px-2 py-1 rounded-xl dark:text-gray-200">
                  {currentPage} <FaChevronDown />
                </button>
                {isOpen && (
                  <div className="absolute bg-white border rounded-md shadow z-10 max-h-60 overflow-auto">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                      <div key={p} onClick={() => handlePageSelect(p)} className={`px-3 py-1 cursor-pointer ${p === currentPage ? "bg-gray-200 font-semibold" : ""}`}>
                        {p}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <button className="border-2 px-1 py-1 rounded-xl disabled:opacity-50" disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)}>
                <img src={rightarrow} alt="" className="w-5 h-5"/>
              </button>
            </div>
          </div>

          {/* Delete Modal */}
          {showDeleteModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg p-6 w-80 text-center shadow-lg dark:bg-black">
                <p className="mb-4 text-gray-700 dark:text-gray-300">Are you sure you want to delete <strong>{productToDelete.name}</strong>?</p>
                <div className="flex justify-between">
                  <button 
                    className="px-4 py-2 rounded bg-gray-300 text-gray-700 hover:bg-gray-400"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                  <button 
                    className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600"
                    onClick={confirmDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Product2;
